import React, { useCallback } from 'react';

interface VolumeControlProps {
  volume: number;
  isMuted: boolean;
  mediaElementId: string;
  onVolumeChange: (volume: number) => void;
  onMuteToggle: () => void;
}

export const VolumeControl = React.memo(function VolumeControl({
  volume,
  isMuted,
  mediaElementId,
  onVolumeChange,
  onMuteToggle,
}: VolumeControlProps) {
  const displayVolume = isMuted ? 0 : volume;

  const handleSliderChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onVolumeChange(parseFloat(e.target.value));
    },
    [onVolumeChange],
  );

  const muteLabel = isMuted || volume === 0 ? 'Unmute' : 'Mute';

  return (
    <div className="kollab-player-volume">
      <button
        className={`kollab-player-btn kollab-player-mute-btn ${isMuted || volume === 0 ? 'kollab-player-mute-btn--muted' : ''}`}
        aria-label={muteLabel}
        data-tooltip={muteLabel}
        aria-controls={mediaElementId}
        onClick={onMuteToggle}
        type="button"
      >
        <span className="kollab-player-btn-icon" aria-hidden="true" />
      </button>
      <input
        type="range"
        className="kollab-player-volume-slider"
        min="0"
        max="1"
        step="0.05"
        value={displayVolume}
        onChange={handleSliderChange}
        aria-label="Volume"
        aria-controls={mediaElementId}
        aria-valuenow={Math.round(displayVolume * 100)}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuetext={`${Math.round(displayVolume * 100)} percent`}
      />
    </div>
  );
});
